import Vue from 'vue'
import VueRouter from 'vue-router'

import home from './routes/home';
import login from './routes/login';
import resetPassword from './routes/reset-password';
import requestNewPassword from './routes/request-new-password';

import authGuard from './hooks/auth-guard';
import registerNavigationGuard from './hooks/register-navigation-guard';
// import sdmGuard from './hooks/sdm-guard';

import patientIdGuard from './hooks/patient-id-guard';
import enabledModuleGuard from './hooks/enabled-module-guard';

import RouterHistory from './hooks/router-history';

Vue.use(VueRouter)

/**
 * Route configuration - index.js
 *
 * @namespace router
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/router/index.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => {
    // resolve error (hide in console) in case of navigation failure ( redirected, duplicated, cancelled or aborted )
    if (VueRouter.isNavigationFailure(err)) {
      return false;
    }
    // else rethrow error
    return Promise.reject(err)
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    home,
    login,
    requestNewPassword,
    resetPassword,
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
});

router.beforeEach(authGuard);
router.beforeEach(enabledModuleGuard);
router.beforeEach((to, from, next) => {
  RouterHistory.savePreviousRoute(from);
  next();
})
router.beforeResolve(patientIdGuard);
router.beforeResolve(registerNavigationGuard);
router.afterEach(RouterHistory.afterRouting);

export default router;